/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-undef */
/* eslint-disable no-console */
/* eslint-disable jsx-a11y/accessible-emoji */
import React, { useState, useEffect } from 'react';
import { Container, Row } from 'reactstrap';
import { axios } from '../../services/ServiceUtils';
import { ChatContainer, CloseButton } from './style';
import { useLanguageContext } from '../../contexts/LanguageContext';
import { getChatLabels } from '../../services/ChatLabelsService';

const ChatComponent = () => {
  const [isOpen, toggleOpen] = useState(false);
  const [chatLabels, setChatLabels] = useState({});

  const onToggleOpen = () => {
    toggleOpen(!isOpen);
  };

  const [isLoading, setIsLoading] = useState(true);
  const { language } = useLanguageContext();

  useEffect(() => {
    getChatLabels(language.locale)
      .then(data => {
        setChatLabels(data);
        setIsLoading(false);
      })
      .catch(e => {
        console.error('error trying to get chat labels', e.response.status);
      });
  }, [language]);

  const offlineButtonStyle = {
    display: 'none',
  };

  return (
    isLoading === false && (
      <Container>
        <Row>
          <ChatContainer language={language} className={isOpen ? 'dfs-chat active-md' : 'dfs-chat'}>
            {(language.locale.toUpperCase() === 'EN-US' || language.locale.toUpperCase() === 'EN-CA' || language.locale.toUpperCase() === 'FR-CA') && (<>
            <div className="dfs-chat__trigger mb-2" >
              <button
                className="dds-chat__action-text--mobile"
                type="button"
                onClick={() => onToggleOpen()}
              >
                <div className="dds__icons d-inline mr-2">💬</div>
                <span id="small-title">{chatLabels.contactSliderSmallTitle}</span>
              </button>
              <button
                className="dds-chat__action-text"
                type="button"
                onClick={() => onToggleOpen()}
              >
                <span id="title">{chatLabels.contactSliderTitle}</span>
              </button>
            </div>

            <div className={isOpen ? 'dfs-chat__content active' : 'dfs-chat__content'}>
              <div className="dfs-chat__content-header">
                <p>{chatLabels.greeting}</p>
                <CloseButton onClick={() => onToggleOpen()}>×</CloseButton>
              </div>
              <ul className="dfs-chat__options">
                {/*Removed the option "Chat with an agent"*/}
                <li>
                  <div className="dds__icons d-inline mr-1">🕾</div>
                  <a
                    id="phone"
                    className="text-decoration-none"
                    href={chatLabels.contactLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    tabIndex={`${isOpen ? 0 : -1}`}
                  >
                    {chatLabels.contact}
                  </a>
                </li>
                <li>
                  <div className="dds__icons d-inline mr-1">🖂</div>
                  <a
                    id="email"
                    className="text-decoration-none"
                    href={chatLabels.emailLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    tabIndex={`${isOpen ? 0 : -1}`}
                  >
                    {chatLabels.email}
                  </a>
                </li>
              </ul>
            </div>
          </>)}
          </ChatContainer>
        </Row>
      </Container>
    )
  );
};

export default ChatComponent;